import React from 'react';
import { KPICards } from '../components/KPICards';
import { TicketTable } from '../components/TicketTable';
import { SLAPriorityQueue } from '../components/SLAPriorityQueue';
import { TeamWorkload } from '../components/TeamWorkload';
import { TrendAnalytics } from '../components/TrendAnalytics';
import { KnowledgeBase } from '../components/KnowledgeBase';
import { RefreshCwIcon } from 'lucide-react';
interface DashboardProps {
  activePage: string;
}
const pageTitles: Record<string, string> = {
  Dashboard: 'Support Dashboard',
  Tickets: 'Ticket Management',
  'SLA Monitor': 'SLA Monitor & Priority Queue',
  Team: 'Team Operations',
  Analytics: 'Trend Analytics',
  'Knowledge Base': 'Knowledge Base'
};
export function Dashboard({
  activePage
}: DashboardProps) {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="p-8 max-w-[1600px] mx-auto space-y-6" data-id="element-323">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8" data-id="element-324">
        <div data-id="element-325">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-326">
            {pageTitles[activePage] || 'Support Dashboard'}
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-327">{today}</p>
        </div>
        <div className="mt-4 md:mt-0 flex items-center space-x-4" data-id="element-328">
          <span className="text-sm text-gray-500 flex items-center" data-id="element-329">
            <span className="w-2 h-2 rounded-full bg-green-500 mr-2" data-id="element-330"></span>
            System Operational
          </span>
          <button className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm" data-id="element-331">
            <RefreshCwIcon className="w-4 h-4" data-id="element-332" />
            <span data-id="element-333">Refresh</span>
          </button>
        </div>
      </div>

      {activePage === 'Dashboard' && <>
          <KPICards data-id="element-334" />
          <TicketTable data-id="element-335" />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-336">
            <div className="lg:col-span-1" data-id="element-337">
              <SLAPriorityQueue data-id="element-338" />
            </div>
            <div className="lg:col-span-2" data-id="element-339">
              <TeamWorkload data-id="element-340" />
            </div>
          </div>
          <TrendAnalytics data-id="element-341" />
          <KnowledgeBase data-id="element-342" />
        </>}

      {activePage === 'Tickets' && <TicketTable data-id="element-343" />}

      {activePage === 'SLA Monitor' && <SLAPriorityQueue data-id="element-344" />}

      {activePage === 'Team' && <TeamWorkload data-id="element-345" />}

      {activePage === 'Analytics' && <TrendAnalytics data-id="element-346" />}

      {activePage === 'Knowledge Base' && <KnowledgeBase data-id="element-347" />}

      <div className="py-4 text-center text-xs text-gray-400" data-id="element-348">
        IT Support Center Dashboard &copy; {new Date().getFullYear()} Mortgage
        Lending Co.
      </div>
    </div>;
}